import { ThunkAction } from '../../../../types/actions';
import { root } from '../../../../store/constants';

export const cardTemplatesOpen = (): ThunkAction => {
    const action = (
    ) => {
        if (!root.App.controller.isRelatedPanelNotOpened()) return;
        root.App.router.navigate(root.App.router.getUrl('card-templates'), {trigger: true});
    };
    return action;
};
